import { render, staticRenderFns } from "./DomainRankingList.vue?vue&type=template&id=0e4e9bc2&scoped=true"
import script from "./DomainRankingList.vue?vue&type=script&lang=js"
export * from "./DomainRankingList.vue?vue&type=script&lang=js"
import style0 from "./DomainRankingList.vue?vue&type=style&index=0&id=0e4e9bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e9bc2",
  null
  
)

export default component.exports